"use client";
import React from "react";
import { Box, RadialProgressBar, Text } from "rizzui";

export default function EvaluationTabContent({
  successEvaluation,
  callStatus,
}) {
  const overallScore = successEvaluation?.filter(
    (property) => property?.title === "overall"
  )[0]?.value;

  const successPercentage = (overallScore / 5) * 100;

  if (!successEvaluation || successEvaluation.length === 0) {
    return (
      <Text className="text-center dark:text-[#758599] font-switzer text-[12px] font-[500]">
        Not available
      </Text>
    );
  }

  if (callStatus !== "completed") {
    return (
      <Text className="text-center dark:text-[#758599] font-switzer text-[12px] font-[500]">
        Success evaluation will appear here once the call is completed.
      </Text>
    );
  }

  return (
    <>
      <Box className="w-full h-[79px] bg-[#191919] rounded-[8px] p-[19px]">
        <Box className="flex gap-[16px]">
          <RadialProgressBar
            size={42}
            trackColor="#3F3F3F"
            value={successPercentage}
            progressColor={
              successPercentage > 60
                ? "#00A861"
                : successPercentage > 39
                ? "#FBBC05"
                : "#F04438"
            }
            progressbarWidth={5}
          />
          <Box className="flex flex-col justify-between">
            <Text className="font-switzer font-[400] text-[#758599] text-[12px]">
              Overall success score
            </Text>
            <Text className="font-switzer font-[500] text-[14px] text-[#FFFFFF]">
              {overallScore} /5
            </Text>
          </Box>
        </Box>
      </Box>
      {successEvaluation?.map(
        (data, i) =>
          data?.title !== "overall" && (
            <Box className="font-switzer text-[14px] my-8 pr-4" key={i}>
              <Box className="flex justify-between font-[500] text-primary-dark">
                <Text>{data?.title}</Text>
                <Text>
                  {data?.score}/{5}
                </Text>
              </Box>
              <ul className="w-[88%] mt-4">
                <li className="text-[#758599] leading-[18px]">
                  {data?.summary}
                </li>
              </ul>
            </Box>
          )
      )}
    </>
  );
}
